/* eslint-disable @typescript-eslint/member-ordering */
import { RestService } from "./../../shared/rest.service";
//import { forEach } from '@angular/router/src/utils/collection';
import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, QueryList, ViewChildren, ChangeDetectorRef, OnDestroy, OnChanges, SimpleChanges } from "@angular/core";
import { NavigationExtras, Router } from "../../../../node_modules/@angular/router";
import { formatArrivalDate } from "../../utils/Functions";
import { FormGroup, FormBuilder, Validators, FormControl, AbstractControl } from "@angular/forms";
import { UserService } from "../../pages/com.usblick.common/auth/user.service";
import { NgxSpinnerService } from "ngx-spinner";
import { MatDialog } from "@angular/material/dialog";
import { MaterialModalAlertComponent } from "app/shared/material-modal-alert/material-modal-alert.component";
import { ItineraryDetailComponent } from "app/itinerary-detail/itinerary-detail.component";
import { Observable, of, Subject } from "rxjs";
import { UbicacionesService } from "app/home/search-box/service/ubicaciones.service";
import { ProductFactoryService } from "services/itinerary/products/product-factory.service";
import { takeUntil } from "rxjs/operators";
import { payload } from "./reservationDataBuilder";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import * as moment from "moment";
import { ItineraryService } from "app/shared/itinerary.service";
import { NotificationService } from "app/shared/notifications/notification.service";
import { formatDate } from "@angular/common";
@Component({
  selector: "usb-body-reservation",
  templateUrl: "./body-reservation.component.html",
  styleUrls: ["./body-reservation.component.scss"],
})
export class BodyReservationComponent implements OnInit, OnDestroy {
@ViewChild('loadingContainer', { static: false }) loadingContainer: ElementRef;
  @ViewChild(ItineraryDetailComponent, { static: false }) itineraryDetail: ItineraryDetailComponent;
  @ViewChildren("pax") paxSelect: QueryList<ElementRef>;
  @Input() itineraryItems: any = [];
  @Input() paxes: any = [];
  @Input() itineraryTotal: any;
  @Input() itineraryId: any;
  @Input() partialReserve: boolean = false;
  @Output() paxesForItems = new EventEmitter<any>();
  @Input() itinerary: any;
  @Input() getClientsSettingAppBooking: any;
  @Input() from: any;
  @Input() onlyTransports!: boolean;
  @Input() clientOwner: any;
  @Input() currencies: any[];
  @Input() currencyAgency: any;
  @Output() loadedPaxes = new EventEmitter<any>();
  destinationOptions: Observable<any[]> = of([]);

  public formatDate = formatArrivalDate;
  productItem: any = [];
  selectedItem = "";
  namehotel: any;
  hotelTitleSelect: string = "";
  // eslint-disable-next-line max-len

  // En tu componente TypeScript
insuranceEmergencyForms = new Map<string, FormGroup>();
insuranceEmergencySelectionMode = new Map<string, boolean>();
insuranceEmergencyOptionsAvailable = true; // true = selector, false = autocomplete

// Para los contactos de emergencia
emergencyContactsOptions: string[] = [
  'Hermano/a',
  'Padre/Madre',
  'Esposo/a',
  'Hijo/a',
  'Amigo/a',
  'Otro familiar',
  'Colega'
];

  paxesInItems: Array<{
    idPax: any;
    itemId: string;
    clientId: number;
    document_number: string;
    first_name: string;
    last_name: string;
    email: string;
    gender: number;
    country_id: string;
    birth_date: string;
    title: string;
    identificationType: string;
    type: string;
    state_id: string;
    phone: string;
    phone2: string;
    city: string;
    address: string;
    postal_code: string;
    idUnique: number;
    relation_ship_catalogue_id: number;
    conditionInsurance?: any;
    paxListIndex: any;
    age: any;
    holder: string;
  }> = [];

  registerClient: boolean = false;
  resultReserve: any = [];
  permitedReservation: boolean = false;
  reserving: boolean = false;
  emailPrimary: any;
  countryPrimary: any;
  documentPrimary: any;
  isReadOnly: any;
  element: HTMLElement;
  element_: HTMLElement;
  transport: any = [];
  ismeridian = false;
  _form: FormGroup;
  message = [];
  transportLabel: string = "Info";
  transportEx: any;
  isCruise: boolean = false;
  selectedValue = "";
  arrRelationShip: string[] = [];
  arrRelationShipAdults: string[] = [];
  foundRelationship: any;
  paxesToShow: any[] = [];
  foundRelationshipAdults: string[] = [];
  commentsRentacar:string = '';
  public paxGroup: boolean = true;
  public onlyAdults: boolean = false;
  public remarks: any[] = [];
  public commentHotels: any;

  public loading: boolean = false;
  public paxAdultsArr: any[] = [];
  public itemsSync: any;
  public results: boolean = false;
  public itemsArr: any[] = [];
  private shouldContinuePromise: Promise<boolean>;
  private shouldContinueResolver: (value: boolean) => void;
  public itemsMap = new Map<string, any>();
  public itemsPerRoom = new Map<string, any>();
  public separateArrays: any[] = [];
  public itemsNewArr: any[] = [];
  public paxesArr: any[] = [];
  public categoryName: string;
  public formData: any;
  public paxesOriginal: any[] = [];
  public appLoading: boolean = true;
  private groupedByBookingCode: { [bookingCode: string]: any[][] } = {};
  styleSidebar: any;
  clientIdFusion: number;

  hotelForm: FormGroup;
  hotelForms: Map<string, FormGroup> = new Map();
  hotelSelectionMode: Map<string, boolean> = new Map();
  hotelQuestionsData: Map<string, any> = new Map();
  hotel_name: string;
  hotelsNameArr: string[] = [];
  hotelsArrOptionsAvailable: boolean = false;

  flightForms = new Map<number, FormGroup>();

  phoneCodeSelected: string = '';
  isHoveredCancelDate: boolean;
  phoneSelectedCountryCode: string;
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  constructor(
    private route: Router,
    private _restService: RestService,
    private fb: FormBuilder,
    public userService: UserService,
    public ngxSpinner: NgxSpinnerService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private ubicacionesService: UbicacionesService,
    private notificationService: NotificationService,
    private productFactory: ProductFactoryService,
    private sanitizer: DomSanitizer,
    private itineraryService: ItineraryService
  ) {

    this.shouldContinuePromise = new Promise<boolean>((resolve) => {
      this.shouldContinueResolver = resolve;
    });
  }


  ngOnInit() {
    this.styleSidebar = JSON.parse(this.getClientsSettingAppBooking?.clients_setting_app_booking?.bookingFlow_sidebar);
    this.clientIdFusion = this.getClientsSettingAppBooking.id;
    this.paxesOriginal = this.paxes;
    this.formData = JSON.parse(localStorage.getItem("form"));
    let foundGroup = false;
    this.itineraryItems.forEach((item) => {
      // this.productItem.$item.id = false;
      if (item.categoryName === "HOTELS") {
        this.namehotel = item.title;

        // Crear una clave que incluya hotelId, arrivalDate y departureDate
        const key = `${item.room?.hotelCode}_${item.arrivalDate}_${item.departureDate}`;

        // Verificar si ya existe un array para esta combinación
        if (this.itemsMap.has(key)) {
          // Agregar el item al array existente
          this.itemsMap.get(key)?.push(item);
        } else {
          // Crear un nuevo array y agregar el item
          this.itemsMap.set(key, [item]);
        }

        // Obtener los arrays separados
        this.separateArrays = Array.from(this.itemsMap.values());

        // Construye una cadena única basada en el hotelId
        const keyItems = `${item.room?.hotelCode}_${item.arrivalDate}_${item.departureDate}`;

        // Verifica si ya existe un elemento con el mismo hotelId
        if (!this.itemsPerRoom.has(keyItems)) {
          // Si no existe, agrega el elemento al mapa y al array correspondiente
          this.itemsPerRoom.set(keyItems, item);
        }
        this.itemsNewArr = Array.from(this.itemsPerRoom.values());

        this.itemsNewArr = this.itemsNewArr.map((item, i) => {
          return { ...item, roomsData: this.separateArrays[i] };
        });
      }

      if (item.categoryName === "TOURS") {

              const formKey = `${item.toursId}_${item.arrivalDate}_${item.departureDate}_${item.id}`;

              if (!this.hotelForms.has(formKey)) {
                const hotelForm = this.fb.group({
                  destination: new FormControl(null, [Validators.required])
                });

                const initialMode = this.hotelsArrOptionsAvailable;
                this.hotelSelectionMode.set(formKey, initialMode);

                hotelForm.get("destination").valueChanges.subscribe((selectedValue) => {
                  if (selectedValue) {
                    this.destinationOptions = this.ubicacionesService.getCitys(selectedValue, 'HOTELS');

                    // Validación manual
                    this.validateHotelSelection(selectedValue, hotelForm, formKey);
                  } else {
                    this.destinationOptions = of([]);
                  }
                });

                this.hotelForms.set(formKey, hotelForm);
              }


          this.itinerary.items.forEach((item: any) => {

            if(item.categoryName === 'HOTELS') {
              this.hotelsNameArr.push(item.title);
            }

            if(this.hotelsNameArr && this.hotelsNameArr.length > 0) {
              this.hotelsArrOptionsAvailable = true;
            }
          });
        // Crear una clave que incluya hotelId, arrivalDate y departureDate
        const key = `${item.toursId}_${item.arrivalDate}_${item.departureDate}_${item.id}`;

        // Verificar si ya existe un array para esta combinación
        if (this.itemsMap.has(key)) {
          // Agregar el item al array existente
          this.itemsMap.get(key)?.push(item);
        } else {
          // Crear un nuevo array y agregar el item
          this.itemsMap.set(key, [item]);
        }

        // Obtener los arrays separados
        this.separateArrays = Array.from(this.itemsMap.values());

        // Construye una cadena única basada en el hotelId
        const keyItems = `${item.toursId}_${item.arrivalDate}_${item.departureDate}_${item.id}`;

        // Verifica si ya existe un elemento con el mismo hotelId
        if (!this.itemsPerRoom.has(keyItems)) {
          // Si no existe, agrega el elemento al mapa y al array correspondiente
          this.itemsPerRoom.set(keyItems, item);
        }
        this.itemsNewArr = Array.from(this.itemsPerRoom.values());

        this.itemsNewArr = this.itemsNewArr.map((item, i) => {
          return { ...item, roomsData: this.separateArrays[i] };
        });
      }

      if (item.categoryName === "RENT-A-CAR") {
        this.namehotel = "Hotel Savoy ACTUALIZIADO";

        // Crear una clave que incluya hotelId, arrivalDate y departureDate
        const key = `${item.rentacarId}_${item.arrivalDate}_${item.departureDate}_${item.id}`;

        // Verificar si ya existe un array para esta combinación
        if (this.itemsMap.has(key)) {
          // Agregar el item al array existente
          this.itemsMap.get(key)?.push(item);
        } else {
          // Crear un nuevo array y agregar el item
          this.itemsMap.set(key, [item]);
        }

        // Obtener los arrays separados
        this.separateArrays = Array.from(this.itemsMap.values());

        // Construye una cadena única basada en el hotelId
        const keyItems = `${item.rentacarId}_${item.arrivalDate}_${item.departureDate}_${item.id}`;

        // Verifica si ya existe un elemento con el mismo hotelId
        if (!this.itemsPerRoom.has(keyItems)) {
          // Si no existe, agrega el elemento al mapa y al array correspondiente
          this.itemsPerRoom.set(keyItems, item);
        }
        this.itemsNewArr = Array.from(this.itemsPerRoom.values());

        this.itemsNewArr = this.itemsNewArr.map((item, i) => {
          return { ...item, roomsData: this.separateArrays[i] };
        });
      }

      if (item.categoryName === "TRANSPORTS") {

        // Crear una clave que incluya hotelId, arrivalDate y departureDate
        const key = `${item.productKey}_${item.arrivalDate}_${item.departureDate}_${item.id}`;

        // Verificar si ya existe un array para esta combinación
        if (this.itemsMap.has(key)) {
          // Agregar el item al array existente
          this.itemsMap.get(key)?.push(item);
        } else {
          // Crear un nuevo array y agregar el item
          this.itemsMap.set(key, [item]);
        }

        // Obtener los arrays separados
        this.separateArrays = Array.from(this.itemsMap.values());

        // Construye una cadena única basada en el hotelId
        const keyItems = `${item.productKey}_${item.arrivalDate}_${item.departureDate}_${item.id}`;

        // Verifica si ya existe un elemento con el mismo hotelId
        if (!this.itemsPerRoom.has(keyItems)) {
          // Si no existe, agrega el elemento al mapa y al array correspondiente
          this.itemsPerRoom.set(keyItems, item);
        }
        this.itemsNewArr = Array.from(this.itemsPerRoom.values());

        this.itemsNewArr = this.itemsNewArr.map((item, i) => {
          return { ...item, roomsData: this.separateArrays[i] };
        });



      }
      if (item.categoryName === "INSURANCE") {

        // Crear una clave que incluya hotelId, arrivalDate y departureDate
        const key = `${item.productKey}_${item.arrivalDate}_${item.departureDate}_${item.id}`;

        // Verificar si ya existe un array para esta combinación
        if (this.itemsMap.has(key)) {
          // Agregar el item al array existente
          this.itemsMap.get(key)?.push(item);
        } else {
          // Crear un nuevo array y agregar el item
          this.itemsMap.set(key, [item]);
        }

        // Obtener los arrays separados
        this.separateArrays = Array.from(this.itemsMap.values());

        // Construye una cadena única basada en el hotelId
        const keyItems = `${item.productKey}_${item.arrivalDate}_${item.departureDate}_${item.id}`;

        // Verifica si ya existe un elemento con el mismo hotelId
        if (!this.itemsPerRoom.has(keyItems)) {
          // Si no existe, agrega el elemento al mapa y al array correspondiente
          this.itemsPerRoom.set(keyItems, item);
        }
        this.itemsNewArr = Array.from(this.itemsPerRoom.values());

        this.itemsNewArr = this.itemsNewArr.map((item, i) => {
          return { ...item, roomsData: this.separateArrays[i] };
        });

        this.initializeInsuranceEmergencyForm(item);
      }
    });
    if (!this.namehotel) {
      this.namehotel = "";
    }
    if (this.paxes) {
      this.paxes.forEach((pax) => {
        if (this.getDataOfPax(pax.idUnique, "relationShip") === null) {
          this.documentPrimary = pax.document_number;
          this.countryPrimary = this.getDataOfPax(pax.idUnique, "country_id");
          this.emailPrimary = this.getDataOfPax(pax.idUnique, "email");
        }

        this.arrRelationShip.push(pax.relation_ship);
        this.foundRelationship = this.arrRelationShip.filter((element: any) => element === "Child");
        this.arrRelationShipAdults.push(pax.relation_ship);
        this.foundRelationshipAdults = this.arrRelationShip.filter((element: any) => element !== "Child");
      });
    } else {
      this.userService.itineraryActive[0].paxlist.forEach((pax) => {
        if (this.getDataOfPax(pax.idUnique, "relationShip") === null) {
          this.documentPrimary = pax.document_number;
          this.countryPrimary = this.getDataOfPax(pax.idUnique, "country_id");
          this.emailPrimary = this.getDataOfPax(pax.idUnique, "email");
        }
      });

      this.userService.itineraryActive.paxlist.forEach((data) => {});
    }

    this.remarks = [
      { name: "Cama matrimonial" },
      { name: "Habitaciones contiguas" },
      { name: "Cliente llegará tarde" },
      { name: "Dos camas" },
    ];

    this.transport = [
      {
        name: "Flight",
        label: "Flight Code",
        placeholder: "AA908",
        value: "flight",
      },
      {
        name: "Train",
        label: "Ship Name",
        placeholder: "TRSB",
        value: "train",
      },
      {
        name: "Cruise",
        label: "Company Name",
        placeholder: "MSC Sinfonía",
        value: "cruise",
      },
    ];
    this.initForm();

    if (this.onlyTransports) {
      this.paxes = this.paxes.filter((element: any, index: number) => {
        // ✅ Mantener los primeros 2 elementos (índices 0 y 1)
         if (element.holder) return true;

        // ✅ Eliminar si los campos están vacíos
        return !(element.first_name === null && element.last_name === null && element.title === null);
      });
    }


    this.paxes.forEach((element: any) => {
      this.arrRelationShip.push(element.relation_ship);
      this.foundRelationship = this.arrRelationShip.filter((element: any) => element === "Child");
    });

    this.getPaxAdults();


this.paxes = [];

  }

  ngOnDestroy() {

  }



  getPaxAdults() {

    this.paxAdultsArr = this.paxes.filter((pax) => pax.type !== "children");

    setTimeout(() => {
      this.appLoading = false;
      this.cdr.detectChanges();
    }, 1200);
  }

  initForm() {
    this._form = this.fb.group({
      arrivalTime: [null, Validators.required],
      transport: ["", Validators.required],
      idComment: ["", Validators.required],
      idTransport: ["", Validators.required],
      cruiseNumber: ["", Validators.required],
    });
  }

  getRandom() {
    return Math.random().toString(36).substring(7);
  }

  indexPax(i) {}

  errorDialog() {
    const dialogRef = this.dialog.open(MaterialModalAlertComponent, {
      width: "415px",
      data: "Este pasajero ya fue seleccionado, elija otro por favor",
      disableClose: true, // Desactivar el cierre al hacer clic fuera del diálogo
    });
  }

  maxPaxDialog(item: any) {
    const dialogRef = this.dialog.open(MaterialModalAlertComponent, {
      width: "415px",
      data: "Usted ya eligio todos los pasajeros para este producto",
      disableClose: true, // Desactivar el cierre al hacer clic fuera del diálogo
    });
  }

  maxChildrenDialog() {
    const dialogRef = this.dialog.open(MaterialModalAlertComponent, {
      width: "415px",
      data: "Usted ya eligio el máximo de pasajeros de tipo niño",
      disableClose: true, // Desactivar el cierre al hacer clic fuera del diálogo
    });
  }

  maxAdultsDialog() {
    const dialogRef = this.dialog.open(MaterialModalAlertComponent, {
      width: "415px",
      data: "Usted ya eligio el máximo de pasajeros de tipo adulto",
      disableClose: true, // Desactivar el cierre al hacer clic fuera del diálogo
    });
  }

  // ageInvalidInItem() {
  //    const dialogRef = this.dialog.open(MaterialModalAlertComponent, {
  //     width: "415px",
  //     data: "Usted ya eligio el máximo de pasajeros de tipo adulto",
  //     disableClose: true, // Desactivar el cierre al hacer clic fuera del diálogo
  //   });
  // }

  setPaxToItem(pax, item, event, index) {
    const selectedOption = event.target.options[event.target.selectedIndex];

    // Acceder a los valores personalizados
    const firstName = selectedOption.dataset.name;
    const lastName = selectedOption.dataset.last_name;
    const relation_ship = selectedOption.dataset.relation_ship_catalogue_id ? selectedOption.dataset.relation_ship_catalogue_id : null;
    // const uid: number = selectedOption.getAttribute("data-idUnique"); // Obtener el valor de 'data-idUnique'
    const uniqueId = selectedOption.dataset.idunique;
    let allowNewPax = this.checkQtyPaxesByCategory(item);

    let email = this.getDataOfPax(uniqueId, "email");
    // let country_id = this.getDataOfPax(pax, "country_id");
    let first_name = this.getDataOfPax(uniqueId, "name");
    let document = pax;
    const birth_date = selectedOption.dataset.birth_date;
    const title = selectedOption.dataset.title;
    const gender = selectedOption.dataset.gender;
    const identificationType = selectedOption.dataset.document_type_id;
    const address = selectedOption.dataset.address;
    let country_id = selectedOption.dataset.country_id;
    const city = selectedOption.dataset.city;
    const state_id = selectedOption.dataset.state_id;
    const phone = selectedOption.dataset.phone;
    const phone_2 = selectedOption.dataset.phone_2;
    const type = selectedOption.dataset.type;
    const clientId = selectedOption.dataset.client_id;
    const age = parseInt(selectedOption.dataset.age, 10);
    const paxListIndex = parseInt(selectedOption.dataset.paxlistindex, 10);
    const phone_code = selectedOption.dataset?.phone_code?.match(/\(\+?\d+\)/)?.[0].replace(/[()]/g, '') ?? '';
    // console.log(clientId)
    const itemIdArr = this.paxesInItems.filter((c) => c.itemId === item.id);
    const maxPaxAdults = item.paxAdults;
    const maxPaxChilds = item.paxChildren;
    let child = "";
    let exists: boolean = false;
    if (type === "children") {
      child = "CH";
    }
    let adult = "";
    if (type !== "children") {
      adult = "AD";
    }

    if (pax != null && allowNewPax && event.target.value != null) {

      // if(type === 'children' && this.ageValidInItem(item, pax, this.paxesInItems)) {
      //   exists = true;
      //   this.ageInvalidInItem()
      // }




      if (this.paxesInItems.some((val) => val.itemId == item.id) && itemIdArr.length === item.paxAdults + item.paxChildren) {
        exists = true;
        this.maxPaxDialog(item);
      }

      if (!exists) {
        if (this.paxesInItems.some((val) => val.itemId == item.id && val.idUnique == uniqueId)) {
          exists = true;
          this.errorDialog();
        }
      }
      if (!exists) {
        if (this.paxesInItems.some((val) => val.itemId == item.id && itemIdArr.some((val) => val.type === child))) {
          const childrenPaxesCount = this.paxesInItems.filter((val) => val.itemId == item.id && val.type === "CH").length;

          if (childrenPaxesCount >= maxPaxChilds) {
            this.maxChildrenDialog();
            exists = true;
          }
        }
      }
      if (!exists) {
        if (this.paxesInItems.some((val) => val.itemId == item.id && itemIdArr.some((val) => val.type === adult))) {
          const adultsPaxesCount = this.paxesInItems.filter((val) => val.itemId == item.id && val.type === "AD").length;

          if (adultsPaxesCount >= maxPaxAdults) {
            this.maxAdultsDialog();
            exists = true;
          }
        }
      }
      if (exists) {
        // console.log("==>pax ya INCLUIDO en el item");
      } else {
        // obtener datos del pax principal
        if (this.getDataOfPax(uniqueId, "relation_ship") === null) {
          this.documentPrimary = pax;
          this.countryPrimary = this.getDataOfPax(uniqueId, "country_id");
          this.emailPrimary = this.getDataOfPax(uniqueId, "email");
        }
        if (pax === null) {
          document = this.documentPrimary;
        }
        if (country_id === null) {
          country_id = this.countryPrimary;
        }
        if (email === "undefined" || email === null) {
          email = this.emailPrimary;
        }
        // if (type === "children") {
        //    if(item.categoryName != 'TRANSPORTS') {
        //   this.paxes = this.paxes.filter((c) => Number(c.idUnique) !== Number(uid));
        //    }
        // }
        // if (type !== "children") {
        //   if(item.categoryName != 'TRANSPORTS') {
        //     this.paxAdultsArr = this.paxAdultsArr.filter((c) => Number(c.idUnique) !== Number(uid));
        //     this.paxes = this.paxes.filter((c) => Number(c.idUnique) !== Number(uid));
        //   }
        // }

        this.paxesInItems.push({
          idPax: this.getRandom(),
          itemId: item.id,
          clientId: clientId ? clientId : null,
          document_number: document,
          first_name: firstName,
          last_name: lastName,
          email: email,
          type: type === "children" ? "CH" : "AD",
          country_id: country_id,
          birth_date: birth_date,
          age: age,
          title: title,
          identificationType: identificationType,
          phone: `${phone_code}${phone}`,
          phone2: "",
          address: address,
          city: city,
          state_id: state_id,
          postal_code: "6301",
          idUnique: uniqueId,
          gender: gender,
          paxListIndex: paxListIndex,
          relation_ship_catalogue_id: Number(relation_ship),
          holder: "true",
        });
        this.paxesForItems.emit(this.paxesInItems);
        this._permitedReservation();
      }
      //this.paxesInItems

    }
    // this.selectedItem = '';
    event.target.value = "";
    this.selectNull();

  }

  paxAlreadySelectedInItem(pax: any, itemId: number): boolean {



  return this.paxesInItems.some(p => Number(p.itemId) === Number(itemId) && Number(p.idUnique) === Number(pax.idUnique));
}

ageValidInItem(pax: any, item: any): boolean {

  // ✅ Adultos siempre son válidos
  if (pax.type === 'adult') {
    return true;
  }

  // 1. Obtener las edades esperadas para este item según su categoría
  const expectedAges = this.getItemExpectedAges(item);

  // 2. Obtener la edad del pasajero
  const agePax = pax.age;
  // 3. Verificar si la edad del pasajero está en las edades esperadas
  if (!expectedAges.includes(agePax)) {
    return false;
  }

  // 4. Contar cuántos niños de esta edad ya han sido asignados a este item
  const assignedChildrenOfAge = this.paxesInItems.filter(p =>
    Number(p.itemId) === Number(item.id) &&
    p.type === 'children' &&
    p.age === agePax
  ).length;

  // 5. Contar cuántos niños de esta edad se necesitan en total para este item
  const totalNeededOfAge = expectedAges.filter(age => age === agePax).length;


  // 6. Verificar si aún hay cupo para esta edad
  if (assignedChildrenOfAge >= totalNeededOfAge) {
    return false;
  }

  // 7. Verificar que no se haya excedido el total de niños permitidos en el item
  const totalChildrenAssigned = this.paxesInItems.filter(p =>
    Number(p.itemId) === Number(item.id) &&
    p.type === 'children'
  ).length;

  const totalChildrenNeeded = expectedAges.length;


  if (totalChildrenAssigned >= totalChildrenNeeded) {
    return false;
  }

  return true;
}

getAgesInItem(item: any): string {
  const expectedAges = this.getItemExpectedAges(item);

  if (!expectedAges || expectedAges.length === 0) {
    return '';
  }

  // Contar frecuencias de cada edad
  const ageCount: { [key: number]: number } = {};
  expectedAges.forEach(age => {
    ageCount[age] = (ageCount[age] || 0) + 1;
  });

  // Formatear el string
  const ageStrings: string[] = [];

  for (const [ageStr, count] of Object.entries(ageCount)) {
    const age = Number(ageStr); // ✅ Convertir a número

    if (count === 1) {
      ageStrings.push(`${age} año${age !== 1 ? 's' : ''}`);
    } else {
      ageStrings.push(`${count} de ${age} años`);
    }
  }

  // Unir con comas y "y"
  let result = '';
  if (ageStrings.length === 1) {
    result = ` (${ageStrings[0]})`;
  } else if (ageStrings.length === 2) {
    result = ` (${ageStrings[0]} y ${ageStrings[1]})`;
  } else {
    const last = ageStrings.pop();
    result = ` (${ageStrings.join(', ')} y ${last})`;
  }

  return result;
}

/**
 * Obtiene las edades esperadas para un item específico según su categoría
 */
getItemExpectedAges(item: any): number[] {
  const categoryId = item.category_id;
  let payloadUpdate;

  if (categoryId === 8) {
    payloadUpdate = item.payloadSync;
  } else {
    payloadUpdate = item.payloadUpdate;
  }

  if (!payloadUpdate) {
    return [];
  }

  let ages: number[] = [];

  switch (categoryId) {
    case 1: // HOTELES
      const roomConfigurations = payloadUpdate.products?.[0]?.others?.hotels?.roomConfiguration;
      if (roomConfigurations && Array.isArray(roomConfigurations)) {
        for (const room of roomConfigurations) {
          if (room.children && Array.isArray(room.children)) {
            ages.push(...room.children.map((age: any) => Number(age)));
          }
        }
      }
      break;

    case 2: // RENT A CAR
      const rentAcarChildren = payloadUpdate.childAge;
      if (rentAcarChildren && Array.isArray(rentAcarChildren)) {
        ages = rentAcarChildren.map((age: any) => Number(age));
      }
      break;

    case 6: // TOURS / EXPERIENCIAS
      const tourChildren = payloadUpdate.products?.[0]?.others?.tours?.children;
      if (tourChildren && Array.isArray(tourChildren)) {
        ages = tourChildren.map((age: any) => Number(age));
      }
      break;

    case 8: // TRANSPORTS / TRASLADOS
      const transferChildren = payloadUpdate.transfers.paxList.children;
      if (transferChildren && Array.isArray(transferChildren)) {
        ages = transferChildren.map((age: any) => Number(age));
      }
      break;

    case 9: // TICKETS
      const ticketChildren = payloadUpdate.products?.[0]?.others?.tours?.children;
      if (ticketChildren && Array.isArray(ticketChildren)) {
        ages = ticketChildren.map((age: any) => Number(age));
      }
      break;

    case 10: // ASISTENCIA / PAQUETES
      const assistanceChildren = payloadUpdate.products?.[0]?.insurances?.paxList?.paxAges?.filter((c: any) => c < 18) || [];
      if (assistanceChildren && Array.isArray(assistanceChildren)) {
        ages = assistanceChildren.map((age: any) => Number(age));
      }
      break;
  }

  return ages;
}


  requestHotel(pax: any) {
    // console.log(pax);
  }

  setTransportToItem(trans) {
    this.transportLabel = this.transport.find((e) => e.value === trans).label;
    this.transportEx = this.transport.find((e) => e.value === trans).placeholder;
    trans == "cruise" ? (this.isCruise = true) : (this.isCruise = false);
  }

  getDataOfPax(pax: number, name: string) {
    // // Verificar si pax es una cadena
    // if (typeof pax == "string") {
    //   // Convertir pax a número si es una cadena
    //   pax = Number(pax);
    // }
    const index = this.paxes.findIndex((val) => Number(val.idUnique) == Number(pax));

    if (name === "name") {
      return this.paxes[index].first_name;
    }
    if (name === "last_name") {
      return this.paxes[index].last_name;
    }
    if (name === "email") {
      return this.paxes[index].email;
    }
    if (name === "country_id") {
      return this.paxes[index].country_id;
    }
    if (name === "relation_ship") {
      return this.paxes[index].relation_ship_catalogue_id;
    }
    if (name === "idUnique") {
      return this.paxes[index].idUnique;
    }
  }

  _permitedReservation() {
    let permited = true;
    this.permitedReservation = false;
    this.itineraryItems.forEach((item) => {
      if (this.checkProductConfirm(item) === false) {
        permited = false;
      }
    });

    this.permitedReservation = permited;
  }

  checkProductConfirm(item: any): boolean {
    const paxesFilter = this.paxesInItems.filter((val) => val.itemId === item.id);
    const overCapacity = paxesFilter.length > item.paxAdults + item.paxChildren;
    if (item.categoryName === "RENT-A-CAR") {
      // eslint-disable-next-line max-len
      if (item?.additionalDriver) {
        return paxesFilter.length === item.paxAdults + 1 + item.paxChildren ? true : false;
      } else {
        return paxesFilter.length === item.paxAdults + item.paxChildren ? true : false;
      }
    }
    // eslint-disable-next-line max-len
    if (item.categoryName === "HOTELS" || item.categoryName === "INSURANCE" || item.categoryName === "CRUISES") {
      return paxesFilter.length === item.paxAdults + item.paxChildren ? true : false;
    }
    // eslint-disable-next-line max-len
    if (item.categoryName === "TOURS") {
      // eslint-disable-next-line max-len
      this.element_ = document.getElementById("hotel-" + item.id) as HTMLElement;
      if (this.element_) {




        // eslint-disable-next-line max-len
        if ((document.getElementById("hotel-" + item.id) as HTMLInputElement).value === "" || !this.checkPaxConfirm(item)) {
          return false;
        }
      }
      return paxesFilter.length >= 1 ? true : false;
    }
    // eslint-disable-next-line max-len
    if (item.categoryName === "DISNEY" || item.categoryName === "PTHEMES") {
      return paxesFilter.length >= 1 ? true : false;
    }

    if (item.categoryName === "TRANSPORTS") {

        if(!this.validFlightInTransport('checkProduct', null, item.id)) {
          return false;
        }

      if (
        (document.getElementById("transport-" + item.id) != null &&
          (document.getElementById("transport-" + item.id) as HTMLInputElement).value === "") ||
        (document.getElementById("idTransport-" + item.id) != null &&
          (document.getElementById("idTransport-" + item.id) as HTMLInputElement).value === "") ||
        (document.getElementById("transport-" + item.id) != null &&
          (document.getElementById("transport-" + item.id) as HTMLInputElement).value === "cruise" &&
          (document.getElementById("cruiseNumber-" + item.id) as HTMLInputElement).value === "")
      ) {
        return false;
      } else {
        return paxesFilter.length >= 1 ? true : false;
      }
    }
  }

  checkPaxConfirm(item: any): boolean {
    let verif = false;
    const paxesFilter = this.paxesInItems.filter((val) => val.itemId === item.id);
    if (item.categoryName === "TOURS") {
      for (let i = 0; i < paxesFilter.length; i++) {
        this.element = document.getElementById("document_number-" + paxesFilter[i].idPax) as HTMLElement;

        if (this.element) {
          const document_number = (document.getElementById("document_number-" + paxesFilter[i].idPax) as HTMLInputElement).value;
          const email = (document.getElementById("email-" + paxesFilter[i].idPax) as HTMLInputElement).value;
          const country_id = (document.getElementById("country_id-" + paxesFilter[i].idPax) as HTMLInputElement).value;
          if (document_number === "" || email === "" || country_id === "") {
            return false;
          } else {
            verif = true;
          }
        } else {
          verif = true;
        }
      }
      return verif === true ? true : false;
    }
  }

  checkQtyPaxesByCategory(item: any): boolean {
    let paxes = 0;
    // console.log("item", item);
    this.hotelTitleSelect = item.titleHotel;

    if (item.categoryName == "RENT-A-CAR") {
      if (item?.additionalDriver) {
        paxes = item.paxAdults + 1 + item.paxChildren;
      } else {
        paxes = item.paxAdults + item.paxChildren;
      }
    } else {
      paxes = item.paxAdults + item.paxChildren;
    }

    let qtyPaxesItem = 0;
    this.paxesInItems.forEach((pax) => {
      if (pax.itemId == item.id) {
        qtyPaxesItem += 1;
      }
    });

    if (qtyPaxesItem <= paxes) {
      return true;
    }

    return false;
  }

  removePax(pax, item, paxData) {
    if (paxData.type === "AD") {
      const paxUntil = this.paxesOriginal.find((c) => Number(c.idUnique) === Number(pax));
      const index = this.paxAdultsArr.findIndex((c) => Number(c.idUnique) === Number(pax));
      if (index === -1) {
        this.paxes.push(paxUntil);
        this.paxAdultsArr.push(paxUntil);
        this.selectNull();
      }
    }
    if (paxData.type === "CH") {
      const paxUntilChild = this.paxesOriginal.find((c) => Number(c.idUnique) === Number(pax));
      const index = this.paxes.findIndex((c) => Number(c.idUnique) === Number(pax));
      if (index === -1) {
        this.paxes.push(paxUntilChild);
        this.selectNull();
      }
    }
    let index = this.paxesInItems.findIndex((val) => val.itemId == item && val.idUnique == pax);
    this.paxesInItems.splice(index, 1);
    this.paxesForItems.emit(this.paxesInItems);
    this._permitedReservation();
  }

  additionalDriver(pax: any, idPax: any) {
    // console.log("this.paxesInItems antes", this.paxesInItems);
    // console.log("pax", pax);
    // console.log("item", idPax);

    // let index = this.paxesInItems.findIndex((val) => val.itemId == item && val.document_number == pax);
    // console.log("index", index);

    for (let i = 0; i < this.paxesInItems.length; i++) {
      this.paxesInItems[i].holder = "false";
      if (this.paxesInItems[i].idPax === idPax) {
        this.paxesInItems[i].holder = "true";
      }
    }
  }

  shouldContinue(event: boolean) {
    this.appLoading = false;
    this.shouldContinueResolver(event);

    if(event) {
      this.cdr.detectChanges();
      this.forceRemoveLoadingScreen(); // ← Llamar a la función
    }

  }

  private forceRemoveLoadingScreen() {
  // Intentar inmediatamente
  this.removeLoadingElements();

  // Reintentar un par de veces más por si acaso
  setTimeout(() => this.removeLoadingElements(), 150);
  setTimeout(() => this.removeLoadingElements(), 300);
}

private removeLoadingElements() {
  let removed = 0;

  // 1. Por clase loading-screen
  document.querySelectorAll('.loading-screen').forEach(el => {
    el.remove();
    removed++;
  });

}

  _return() {
    this.userService.stepReservation = "two";
  }

  getPaxesInfo(paxes: any): any {
    let paxesResult = [];
    paxes.forEach((paxFilter) => {
      let pax = paxes.find((val) => val.idUnique == paxFilter.idUnique);
      paxesResult.push(pax);
    });
    // this.ngxSpinner.hide();
    return paxesResult;
  }
  public hotelArr: any[] = [];
  categorys = {
    HOTELS: [
      {
        product: [],
      },
    ],
    RENT_A_CAR: [
      {
        product: [],
      },
    ],
    TOURS: [
      {
        product: [],
      },
    ],
    TRANSPORTS: [
      {
        product: [],
      },
    ],
  };



  /// versión en Lote de reservas Yovanny 01/01/2024
  async _onSubmit() {
    this.reserving = true;

    this.results = true;
    this.groupedByBookingCode = {};
    this.itemsSync = this.itineraryItems;

    if(!this.validQuestionsProducts()) {
      this.reserving = false;
      return;
    }

    if(!this.validContactEmergencyProducts()) {
      this.reserving = false;
      return;
    }

    if(!this.validFlightInTransport('checkOnSubmit', this.itemsSync, -1)) {
      this.reserving = false;
      return;
    }

    for (const item of this.itemsSync) {

      const isCategory8 = item.category_id === 8;
      const isFirstWay = item.firstWay > 0;

      const bookingCode = item.bookParam;

      // Un mismo bookParam puede repetirse entre varios pares ida/vuelta.
      // Se cierra un par apenas se junta el firstWay 1 y el 2; el siguiente
      // 1 para ese mismo bookParam abre un par nuevo, así quedan separados
      // aunque compartan bookParam.
      if (isCategory8 && isFirstWay && bookingCode) {
        if (!this.groupedByBookingCode[bookingCode]) {
          this.groupedByBookingCode[bookingCode] = [];
        }
        const pairs = this.groupedByBookingCode[bookingCode];
        let currentPair = pairs[pairs.length - 1];
        if (!currentPair || currentPair.length === 2) {
          currentPair = [];
          pairs.push(currentPair);
        }
        currentPair.push(item.id);
      }

    }
// return;
    const itemTransports = this.itemsSync.filter(item =>
        item.category_id === 8 && this.needsFlight(item)
    );

    if(itemTransports && itemTransports.length > 0) {

        itemTransports.forEach((transport: any) => {

          const productReserve = this.itemsSync.find(c => c.id === transport.id);
          const itineraryItem = this.itineraryService?.itinerary?.items.find(c => c.id === transport.id);

          itineraryItem.fly = productReserve?.selectedFlight || null;

        });

        // const item = this.itineraryService.itinerary.items.find(c => c.id === this.item.id);
        this.itineraryService.itinerary.clientId = this.itineraryService.itinerary.client_id;
        this.itineraryService.updateItinerary(this.itineraryService.itinerary);

    }


    this.itineraryDetail.itineraryItemsReserve = this.itineraryItems;
    this.itineraryId = this.itemsSync[0].itinerary_id;
    await this.itineraryDetail.updateCards(true, 'reserve');
    const shouldContinueValue = await this.shouldContinuePromise;


    let contadodrItemsFor: number = 0;
    this.appLoading = true;

    if (!shouldContinueValue) {
      let index = 0;
      this.itineraryItems.forEach((item) => {
        contadodrItemsFor++;
        const paxesFilter = this.paxesInItems.filter((val) => val.itemId == item.id);
        let paxesData = this.getPaxesInfo(paxesFilter);
        this.paxesArr.push(paxesData);
        this.categoryName = item.categoryName;

      });

      try {
            const res = await payload(
              this.itemsNewArr,
              this.paxesArr,
              this.userService,
              this.itineraryId,
              this.commentsRentacar,
              this.groupedByBookingCode,
              this._restService,
              this.itineraryItems,
              this.paxesInItems,
              this.hotel_name,
              this.productFactory
            );

            this.appLoading = false;
            // if (res?.data && res?.data.reservation_id) {
              // console.log('res', res);
              this.confirmationRedirect(res?.data?.reservation_id);
            // }

          } catch (error) {
            this.reserving = false;
            this.appLoading = false;
            console.error("Error al crear reserva:", error);
    }
      index++;
      return true;
    } else {

      const dialogRef = this.dialog.open(MaterialModalAlertComponent, {
                    height: "auto",
                    width: "500px",
                    data: "Hubo un cambio en los productos agregados, por favor revise antes de continuar",
                    disableClose: true,
                  });

                  dialogRef.afterClosed().subscribe(result => {
                    const currentRoute = this.route.url;
                    if(this.itineraryId) {
                       if (currentRoute !== `/itinerary-detail?id=${this.itineraryId}&stat=false&screen=detail`) {
                     this.route.navigateByUrl(`/itinerary-detail?id=${this.itineraryId}&stat=false&screen=detail`);
                    }
                    // console.log('result', result);
                    }
                  });
    }
  }

  validFlightInTransport(typeReturn: string, itemSync: any, itemId: number): boolean {

    if(!itemSync && typeReturn !== 'checkOnSubmit') {
          itemSync = this.itineraryItems;
    }

    const filteredTransports = itemSync.filter(item =>
        item.category_id === 8 && this.needsFlight(item)
    );

    if(filteredTransports && filteredTransports.length === 0) {
      return true;
    }

    let formsInvalidos: any[] = [];

    if(typeReturn === 'checkProduct') {

      const transportItem = filteredTransports.find(item => item.id === itemId);

      if(transportItem && transportItem?.selectedFlight) {
        return true;
      } else {
        return false;
      }
    }

    filteredTransports.forEach((transport) => {
        const flightForm = this.getFlightForm(transport);
        if (flightForm && flightForm.invalid) {
            flightForm.markAllAsTouched();
            formsInvalidos.push(transport);
        } else if (flightForm) {
            const selectedFlight = flightForm.get('selectedFlight')?.value;

            // ✅ Validar que el vuelo seleccionado tenga datos mínimos
            if (!selectedFlight && !selectedFlight.id) {
                flightForm.get('selectedFlight')?.setErrors({ invalidFlight: true });
                formsInvalidos.push(transport);
            } else {
                // ✅ Guardar el vuelo seleccionado
                transport.selectedFlight = selectedFlight;
                if (transport.payload && transport.payload[0]?.transfers) {
                    transport.payload[0].transfers.selectedFlight = selectedFlight;
                }
            }
        }
    });

    if (formsInvalidos.length > 0) {

      if(typeReturn === 'checkOnSubmit') {
         const mensaje = formsInvalidos.length === 1
            ? `Complete la información de vuelo para el transporte que lo requiere antes de continuar.`
            : `Complete la información de vuelo para ${formsInvalidos.length} transporte(s) que lo requieren antes de continuar.`;
        this.notificationService.error(mensaje);
        }

        return false;
    }

    return true;
}

validQuestionsProducts(): boolean {
  const filteredToursProduct = this.itemsSync.filter(c => c.category_id === 6);

  let formsInvalidos: any[] = [];

  filteredToursProduct.forEach((tour) => {
    const requiereHotel = tour.categoryName === 'TOURS' && tour.subCategoryId === 6 && this.getQuestionsHotelRefer(tour);

    if (requiereHotel) {
      const formKey = `${tour.toursId}_${tour.arrivalDate}_${tour.departureDate}_${tour.id}`;
      const hotelForm = this.hotelForms.get(formKey);

      if (hotelForm && hotelForm.invalid) {
        // Marcar todos los controles como touched para mostrar errores
        hotelForm.markAllAsTouched();
        formsInvalidos.push(tour);
      } else {

          const hotelValue = hotelForm.get('destination').value;
          const hotelQuestion = tour.questions?.find((q: any) => q.code === 'HOTEL' || q.code === 'HOTEL_NAME');

          if (hotelQuestion) {
            hotelQuestion.text = hotelValue.name || hotelValue;
          }
      }
    }
  });

  if (formsInvalidos.length > 0) {
    this.notificationService.error(`Complete correctamente la información de hotel para ${formsInvalidos.length} tour(s) antes de continuar.`);
    return false;
  }

  return true;
}

validContactEmergencyProducts(): boolean {

    const filteredInsuranceProduct = this.itemsNewArr.filter(c => c.category_id === 10);

    let formsInvalidos: any[] = [];

    filteredInsuranceProduct.forEach((insurance) => {

      const formKey = `${insurance.id}_emergency`;
      const insuranceEmergencyForm = this.insuranceEmergencyForms.get(formKey);

      if (insuranceEmergencyForm && insuranceEmergencyForm.invalid) {
        // Marcar todos los controles como touched para mostrar errores
        insuranceEmergencyForm.markAllAsTouched();
        formsInvalidos.push(insurance);
      } else {

          const insuranceEmergencyValue = insuranceEmergencyForm.value;
          insurance.contact_emergency = {name: insuranceEmergencyValue.contactName, phone: `${insuranceEmergencyValue.contactPhoneCode}${insuranceEmergencyValue.contactPhone}`};
      }

  });

  if (formsInvalidos.length > 0) {
    this.notificationService.error(`Complete correctamente la información de contacto de emergencia para ${formsInvalidos.length} asistencia(s) antes de continuar.`);
    return false;
  }

  return true;
}

  index: number = 0;

  clientIdPaxes(paxesResult: any, paxesValue: any): number {
    // console.log("inicio");
    // console.log("paxesResul : ", paxesResult);
    // console.log("paxesValue: ", paxesValue);
    let paxDataValues = paxesValue;
    let value: number = null;
    paxDataValues = paxDataValues.forEach((paxes: any, index: number) => {
      // console.log(paxes);
      const documentPaxes = paxes.document_number;
      const documentPaxesResult = paxesResult[index].identification;

      if (documentPaxes === documentPaxesResult) {
        value = paxes.clientId;

        paxesResult = paxesResult.map((p: any) => {
          //comentado  yovanny 04-052-024
          // console.log(p);
          p.clientId = value ? value : null;
          return p;
        });
      }
      return value;
    });
    // console.log(paxesResult);
    return paxesResult;
  }


  requestCommentHotel(item?: any, value?: any) {
    this.commentHotels = value;
    // console.log(this.itineraryItems)
    // console.log (item)
    const index = this.itineraryItems.findIndex((c) => c.productKey === item.productKey);
    // console.log(index)
    if (index !== -1 && index >= 0) {
      const itemSelected = this.itineraryItems[index];

      // Inicializa remarksSelect si aún no se ha hecho
      if (!itemSelected.remarksSelect) {
        itemSelected.comments = "";
      }

      if(item.categoryName === 'RENT-A-CAR'){
        this.commentsRentacar = value;
      }

      itemSelected.comments = value;
    }
  }

  initializeRemarksSelect() {
    return {
      doublebed: false,
      adjoiningRooms: false,
      clientWillBelate: false,
      twoBeds: false,
    };
  }

  requestRoomHotel(item?: any, remark?: any): any {
    // console.log(item);
    // console.log(remark);

    const index = this.itineraryItems.findIndex((c) => c.productKey === item.productKey);
    // console.log(index);
    if (index !== -1) {
      const itemSelected = this.itineraryItems[index];
      // console.log(itemSelected);

      // Inicializa remarksSelect si aún no se ha hecho
      if (!itemSelected.remarksSelect) {
        itemSelected.remarksSelect = this.initializeRemarksSelect();
      }

      switch (remark) {
        case "Cama matrimonial":
          itemSelected.remarksSelect.doublebed = !itemSelected.remarksSelect.doublebed;
          break;
        case "Habitaciones contiguas":
          itemSelected.remarksSelect.adjoiningRooms = !itemSelected.remarksSelect.adjoiningRooms;
          break;
        case "Cliente llegará tarde":
          itemSelected.remarksSelect.clientWillBelate = !itemSelected.remarksSelect.clientWillBelate;
          break;
        case "Dos camas":
          itemSelected.remarksSelect.twoBeds = !itemSelected.remarksSelect.twoBeds;
          break;
      }

      // console.log(itemSelected.remarksSelect);
      // console.log(this.itineraryItems);
    }
  }

  phoneComplete(phone: number | string): string {
    // console.log(phone)
    return phone.toString().padStart(10, '0');
  }

  confirmationRedirect(reservationId: number) {


    if (!this.partialReserve) {
      let goToURL: string;
      let navigationExtras: NavigationExtras;

      goToURL = "DetailsSummaryItinerary";
      navigationExtras = {
        queryParams: {
          from: "save-draft-reserve",
          itineraryId: this.itineraryId,
        },
      };
      this.route.navigate([goToURL], navigationExtras);
      this.reserving = false;
    } else {
      let goToURL: string;
      let navigationExtras: NavigationExtras;
      goToURL = "DetailsSummaryItinerary";
      navigationExtras = {
        queryParams: {
          from: "partial-reserve",
          itineraryId: this.itineraryId,
        },
      };
      this.route.navigate([goToURL], navigationExtras);
      this.reserving = false;

    }
  }

  postMainTransaction(result) {
    let json = JSON.parse(localStorage.getItem("nrPayment"));

    json.paymentMethods.forEach((element) => {
      element.referenceId = result.id;
    });
    // console.log(json)
    this._restService.doPost("app", "transactionMaster", json).subscribe((response: any) => {
    });
  }

  selectNull() {
    if (this.paxSelect) {
      this.paxSelect.forEach((pax) => {
        pax.nativeElement.value = null;
      });
    }
  }

  extractNameTransport(form: any, type: string, itemPayload: any): string {
    switch(type) {
      case 'origin':
        switch(itemPayload.transfers.pickupLocation.type) {
          case 'hotel':
            return `${form.name}`;
          case 'airport':
            return `${form.name} (${form.iata})`;
          case 'city':
            return `${form.value}`;
        }
      case 'destination':
        switch(itemPayload.transfers.dropoffLocation.type) {
          case 'hotel':
            return `${form.name}`;
          case 'airport':
            return `${form.name} (${form.iata})`;
          case 'city':
            return `${form.value}`;
        }
    }
  }

  extractAddressType(form: any, type: string, itemPayload: any): string {
    switch(type) {
      case 'origin':
        switch(itemPayload.transfers.pickupLocation.type) {
          case 'hotel':
            return `, ${form.city_name} (${form.country_code})`;
          case 'airport':
            return '';
          case 'destination':
            return `, ${form.city_province} (${form.country_code})`;
        }
      case 'destination':
        switch(itemPayload.transfers.dropoffLocation.type) {
          case 'hotel':
            return `, ${form.city_name} (${form.country_code})`;
          case 'airport':
            return '';
          case 'destination':
            return `, ${form.city_province} (${form.country_code})`;
        }
    }
  }

  getMessageFirstTime(pickupOrDropoff: any,input: string): string {

  let firstOrigin = {};
  let firstDestination = {};

  firstOrigin = input === 'origin' ? pickupOrDropoff : {};
  firstDestination = input === 'destination' ? pickupOrDropoff : {};

  let message: string = '';
  const messageFly = 'Hora arribo del vuelo';
  const messageDestination = 'Hora pickup del hotel';

  if(firstOrigin && firstOrigin['type']) {
    message = firstOrigin['type'] === 'airport' ? messageFly : messageDestination;
  }

  if(message === '') {
    message = firstDestination && firstDestination['type'] === 'airport' ? messageFly : messageDestination;
  }

  return message

  }

  // Manejar selección desde el select
onHotelSelectedFromSelect(hotelName: string, hotelForm: FormGroup) {
  hotelForm.get('destination').setValue(hotelName);
  hotelForm.get('destination').markAsTouched();

  // Limpiar errores ya que se seleccionó del listado válido
  hotelForm.get('destination').setErrors(null);
}

// Manejar selección desde el autocomplete
onHotelSelectedFromAutocomplete(hotel: any, hotelForm: FormGroup) {
  hotelForm.get('destination').setValue(hotel);
  hotelForm.get('destination').markAsTouched();

  // Limpiar errores ya que se seleccionó del autocomplete válido
  hotelForm.get('destination').setErrors(null);
}

// Validador actualizado para ambos modos
hotelSelectionValidator(control: FormControl) {
  const value = control.value;
  // Si está vacío
  if (!value) {
    return { required: true };
  }

  // Modo selector: value es string (nombre del hotel)
  if (typeof value === 'string') {
    // En modo selector, cualquier selección es válida
    return null;
  }

  // Modo autocomplete: value es objeto hotel
  if (typeof value === 'object' && value.name) {
    return null; // Válido
  }
  // Caso inválido: texto escrito pero no seleccionado del autocomplete
  return { invalidSelection: true };
}


    /**
 * Función de display para mostrar el valor seleccionado en campos de autocompletado
 *
 * Este método determina qué propiedad del objeto seleccionado mostrar en el input
 * después de la selección, con soporte para múltiples estructuras de datos.
 *
 * @param {any} name - Objeto seleccionado del autocompletado
 * @returns {string} - Valor a mostrar en el campo de input
 *
 * @logic
 * - Prioridad 1: name.name (para objetos con propiedad name)
 * - Prioridad 2: name.city_name (para objetos con propiedad city_name)
 * - Retorna undefined si el objeto no tiene propiedades válidas
 *
 * @supportedStructures
 * - { name: "Hotel Name" } → "Hotel Name"
 * - { city_name: "New York" } → "New York"
 *
 * @usage
 * Utilizado por componentes mat-autocomplete para display del valor seleccionado
 */
  displayFn(name: any) {
    if (name) {
      if(name.name !== undefined) {
        return name.name;
      }
      if (name.city_name !== undefined) {
        return name.city_name;
      }
    }
  }

    /**
 * Actualiza las propiedades de destino basado en la selección del usuario
 *
 * Este método procesa el objeto seleccionado del autocompletado y actualiza
 * múltiples propiedades relacionadas con el destino de viaje.
 *
 * @param {any} event - Objeto seleccionado con información de destino
 * @returns {void}
 *
 * @propertiesUpdated
 * - destiny: Nombre de la ciudad (para display)
 * - selectedDestiny: Código IATA de la ciudad (para backend)
 * - _longDestination: Nombre completo de destino
 * - country: Código IATA del país
 * - country_name: Nombre del país
 * - province_name: Provincia/estado de la ciudad (formateado)
 * - hotel_id/hotel_name: Si es hotel en lugar de ciudad
 *
 * @logic
 * - Detecta automáticamente si es ciudad o hotel
 * - Formatea province_name con comma prefix opcional
 * - Mantiene consistencia entre propiedades de display y backend
 */
  updateMySelection(event: any) {
    if (event && typeof event === 'string') {
      this.hotel_name = event;
    } else {
      this.hotel_name = event.name ? event.name : "";
    }

    }

      /**
 * Convierte un string a formato de título (Title Case) con manejo de valores nulos
 *
 * Este método transforma un string capitalizando la primera letra de cada palabra
 * y poniendo el resto en minúsculas, con validación robusta para valores edge.
 *
 * @param {any} val - Valor a capitalizar (se convierte a string si es posible)
 * @returns {string} - String en Title Case o valor original si no es capitalizable
 *
 * @validation
 * - Rechaza undefined, null y string vacío
 * - Retorna el valor original si no pasa validación
 *
 * @process
 * 1. toLowerCase(): Convierte todo a minúsculas
 * 2. trim(): Elimina espacios en blanco al inicio/final
 * 3. split(" "): Divide por espacios en array de palabras
 * 4. map(): Capitaliza primera letra de cada palabra
 * 5. join(" "): Une palabras con espacios
 *
 * @example
 * capitalize("new york city") → "New York City"
 * capitalize("juan pérez") → "Juan Pérez"
 * capitalize(null) → null
 */
  capitalize(val: any) {
    if(val !== undefined && val !== null && val !== '') {
      return val
        .toLowerCase()
        .trim()
        .split(" ")
        .map((v) => v[0].toUpperCase() + v.substr(1))
        .join(" ");
    }
  }

changeSelectHotel(item: any): void {
  const formKey = `${item.toursId}_${item.arrivalDate}_${item.departureDate}_${item.id}`;
  const currentMode = this.hotelSelectionMode.get(formKey);

  // Cambiar al modo opuesto
  this.hotelSelectionMode.set(formKey, !currentMode);

  // Resetear el valor del formulario
  const hotelForm = this.hotelForms.get(formKey);
  if (hotelForm) {
    hotelForm.get('destination').setValue(null);
    hotelForm.get('destination').markAsUntouched();
  }
}

getRemarksItem(remarks: string[]): string {
    if (!remarks?.length) return 'No hay remarks para este servicio';

    const validRemarks = remarks.filter(remark => remark?.trim());
    return validRemarks.length > 0 ? validRemarks.join('. ') : 'No hay remarks para este servicio';
}


getQuestionsHotelRefer(item): boolean {
  return item.experience.questions.find(c => c.code === 'HOTEL' || c.code === 'HOTEL_NAME');

}

getHotelSelectionMode(item: any): boolean {
  const formKey = `${item.toursId}_${item.arrivalDate}_${item.departureDate}_${item.id}`;
  return this.hotelSelectionMode.get(formKey) ?? this.hotelsArrOptionsAvailable;
}

getHotelForm(item: any): FormGroup | null {
  const formKey = `${item.toursId}_${item.arrivalDate}_${item.departureDate}_${item.id}`;
  return this.hotelForms.get(formKey) || null;
}

onHotelBlur(hotelForm: FormGroup, formKey: string) {
  const value = hotelForm.get('destination').value;
  this.validateHotelSelection(value, hotelForm, formKey);
  hotelForm.get('destination').markAsTouched();
}

validateHotelSelection(value: any, hotelForm: FormGroup, formKey: string) {
  const isSelectorMode = this.hotelSelectionMode.get(formKey);

  if (isSelectorMode) {
    // En modo selector, cualquier selección es válida
    hotelForm.get('destination').setErrors(null);
  } else {
    // En modo autocomplete, solo objetos son válidos
    if (typeof value === 'object' && value.name) {
      hotelForm.get('destination').setErrors(null);
    } else if (typeof value === 'string') {
      // Texto escrito pero no seleccionado - marcar error
      hotelForm.get('destination').setErrors({ invalidSelection: true });
    }
  }
}

getItem(item): void {

}

initializeInsuranceEmergencyForm(item: any) {
  const formKey = `${item.id}_emergency`;

  if (!this.insuranceEmergencyForms.has(formKey)) {
    const insuranceEmergencyForm = this.fb.group({
      contactName: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(50)]),
      contactPhoneCode: new FormControl('', Validators.required),
      contactPhone: new FormControl('', [
        Validators.required,
        Validators.pattern(/^[+]?[\d\s\-()]{8,}$/)
      ])
    });

    // Establecer modo inicial
    const initialMode = this.insuranceEmergencyOptionsAvailable;
    this.insuranceEmergencySelectionMode.set(formKey, initialMode);

    this.insuranceEmergencyForms.set(formKey, insuranceEmergencyForm);

    // SUSCRIPCIÓN para validar contactPhoneCode
    insuranceEmergencyForm.get('contactPhoneCode').valueChanges.subscribe(value => {
      // Obtener el modo actual para este formulario específico
      const currentMode = this.insuranceEmergencySelectionMode.get(formKey);

      // Ejecutar el validador CON EL FORMKEY
      this.codePhoneValidator(insuranceEmergencyForm, formKey);
    });

    // Validación inicial CON EL FORMKEY
    const initialModeValue = this.insuranceEmergencySelectionMode.get(formKey);
    this.codePhoneValidator(insuranceEmergencyForm, formKey);
  }
}

getInsuranceEmergencyForm(item: any): FormGroup | null {
  const formKey = `${item.id}_emergency`;
  return this.insuranceEmergencyForms.get(formKey) || null;
}

getInsuranceEmergencySelectionMode(item: any): boolean {
  const formKey = `${item.id}_emergency`;
  return this.insuranceEmergencySelectionMode.get(formKey) ?? this.insuranceEmergencyOptionsAvailable;
}



changeEmergencyContactMode(item: any) {
  const formKey = `${item.id}_emergency`;
  const currentMode = this.insuranceEmergencySelectionMode.get(formKey);
  const form = this.insuranceEmergencyForms.get(formKey);

  if (form) {
    // Cambiar modo y resetear el campo
    this.insuranceEmergencySelectionMode.set(formKey, !currentMode);
    form.get('contactType').setValue(null);
    form.get('contactType').markAsUntouched();
  }
}

onEmergencyContactBlur(form: FormGroup, formKey: string) {
  const value = form.get('contactType').value;
  form.get('contactType').markAsTouched();
}

// Para manejar la selección desde el autocomplete
onEmergencyContactSelected(value: string, form: FormGroup) {
  form.get('contactType').setValue(value);
  form.get('contactType').markAsTouched();
}
  filteredCountries = [];
  public countriesData: any[] = [];
  filterCountries(searchText: string) {
    if (searchText) {
      this.filteredCountries = this.countriesData.filter(country =>
        country.country_name.toLowerCase().includes(searchText.toLowerCase())
      );
    } else {
      this.filteredCountries = this.countriesData;
    }
  }

  displayCountry = (country: any) => {
    if(country) {
      if (!this.filteredCountries) {
        console.error('filteredCountries is not defined');
        return '';
      }
      let countryData = this.filteredCountries.find(c => Number(c.phone_code) === Number(country));
      if(country === null) {
        countryData = null;
      }
      return countryData ? `+${countryData.phone_code}` : '';
    }
  }

       /**
   * Bloquea la entrada de caracteres no deseados (`e`, `E`, `+`, `-`) en campos numéricos.
   * @param event El evento de teclado.
   */
blockInvalidKeys(event: KeyboardEvent, input?: string) {
    const key = event.key;

    switch (input) {
        case 'name':
            // Permitir teclas especiales: Backspace, Delete, Tab, Escape, Enter, y las flechas
            if (
              [
                'Backspace',
                'Delete',
                'Tab',
                'Escape',
                'Enter',
                'ArrowLeft',
                'ArrowRight',
              ].includes(key)
            ) {
              return; // Permitir estas teclas
            }

            // Bloquear caracteres que no coincidan con letras, acentos, ñ o espacios
            if (!/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]$/.test(key)) {
              event.preventDefault();
            }
            break;

        case 'number':
            if (['e', 'E', '+', '-', ',', '.'].includes(key)) {
                event.preventDefault();
              }
            break;
    }
  }

    updateMySelectionNationality(event: any, item: any) {
    if(event) {
      const form = this.getInsuranceEmergencyForm(item);

      form.get('contactPhoneCode').setValue(event);
      form.get('contactPhoneCode').setErrors(null);
      form.get('contactPhoneCode').updateValueAndValidity();
      const phoneSelected = this.countriesData.find(c => c.phone_code === event);
      this.phoneSelectedCountryCode = phoneSelected?.country_code;
      this.phoneCodeSelected = `+${phoneSelected.phone_code}`;
    }
  }


  resetPhoneCode(item: any): void {
     const form = this.getInsuranceEmergencyForm(item);
     form.get('contactPhoneCode').setValue('');
    form.get('contactPhoneCode').setErrors({error: true});
    this.phoneCodeSelected = '';
  }

    getCountries() {
      this._restService.doGet("api", "/utilities/countries")
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe({
        next: (res: any) => {
          this.countriesData = res.Countrys;
          this.filteredCountries = this.countriesData;
        }
      })


    }
// Agrega esta variable en tu componente
lastValidPhoneCodes = new Map<string, any>(); // Mapa: formKey -> último valor válido

codePhoneValidator(form: FormGroup, formKey: string) {
  const phoneCodeControl = form.get('contactPhoneCode');

  if (!phoneCodeControl) return;

  const value = phoneCodeControl.value;
  const lastValid = this.lastValidPhoneCodes.get(formKey);


  // Si el campo está vacío, NO hacer nada (el required se encarga)
  if (!value || value.trim() === '') {
    // Si había un lastValid y ahora está vacío, limpiarlo
    if (lastValid) {
      this.lastValidPhoneCodes.delete(formKey);
    }
    return;
  }

  // Si ya teníamos un valor válido guardado
  if (lastValid) {
    // Si el valor actual ES IGUAL al último válido = OK
    if (value === lastValid) {
      // Limpiar nuestro error si existe
      this.clearInvalidSelectionError(phoneCodeControl);
    }
    // Si el valor actual ES DIFERENTE al último válido = ERROR
    else {
      this.setInvalidSelectionError(phoneCodeControl);
    }
  }
  // Si NO tenemos un valor válido guardado aún
  else {
    // Verificar si es un código válido por primera vez
    const isValidPhoneCode = /^\d{1,4}$/.test(value.trim());

    if (isValidPhoneCode) {
      // Es válido por primera vez, lo guardamos
      this.lastValidPhoneCodes.set(formKey, value.trim());
      this.clearInvalidSelectionError(phoneCodeControl);
    } else {
      // No es válido = ERROR
      this.setInvalidSelectionError(phoneCodeControl);
    }
  }
}

// Métodos auxiliares
private setInvalidSelectionError(control: AbstractControl): void {
  const currentErrors = control.errors || {};
  control.setErrors({
    ...currentErrors,
    invalidSelection: true
  });
}

private clearInvalidSelectionError(control: AbstractControl): void {
  const currentErrors = control.errors;
  if (currentErrors && currentErrors.invalidSelection) {
    delete currentErrors.invalidSelection;
    control.setErrors(Object.keys(currentErrors).length > 0 ? currentErrors : null);
  }
}

  selectedConditionInPax(item: any, pax: any, event: any): void {

    const paxSelect = this.paxesInItems.find(c => Number(c.idUnique) === Number(pax.idUnique));

    if(paxSelect) {
      paxSelect.conditionInsurance = JSON.parse(event);
    }

  }

getConditionsInsurances(item: any, pax: any): any[] {
  const conditions = [];

  if (!item?.form?.paxes) {
    return conditions;
  }

  // Variables para controlar condiciones
  let hasPreExistingConditionFound = false;
  let isTravellingFound = false;
  let pregnancyInfo = null;

  // Buscar condiciones en TODOS los paxes
  item.form.paxes.forEach(formPax => {
    if (formPax.addons && Array.isArray(formPax.addons)) {
      formPax.addons.forEach(addon => {
        if (addon === 'hasPreExistingCondition') {
          hasPreExistingConditionFound = true;
        }
        else if (addon === 'isTravelling') {
          isTravellingFound = true;
        }
        else if (addon === 'isPregnant' && formPax.pregnancyWeeks) {
          // Guardar info del embarazo (semanas)
          pregnancyInfo = {
            weeks: formPax.pregnancyWeeks,
            fromPaxAge: formPax.age
          };
        }
      });
    }
  });

  // Agregar condiciones
  if (hasPreExistingConditionFound) {
    conditions.push({
      value: 'hasPreExistingCondition',
      label: 'Preexistencia'
    });
  }

  if (isTravellingFound) {
    conditions.push({
      value: 'isTravelling',
      label: 'En viaje'
    });
  }

  // Verificar embarazo
  if (pregnancyInfo) {
    const age = this.calculateAgeFromBirthDate(pax.birth_date);
    if (age >= 16) {
      conditions.push({
        value: 'isPregnant',
        label: pregnancyInfo.weeks ?
          `Embarazo (${pregnancyInfo.weeks} semanas)` :
          'Embarazo',
        weeks: pregnancyInfo.weeks
      });
    }
  }

  return conditions;
}

private calculateAgeFromBirthDate(birthDate: string): number {
  if (!birthDate) return 0;

  // Formato esperado: "1910-08-07"
  const parts = birthDate.split('-');
  if (parts.length !== 3) return 0;

  const birthYear = parseInt(parts[0], 10);
  const birthMonth = parseInt(parts[1], 10) - 1; // Meses en JS son 0-11
  const birthDay = parseInt(parts[2], 10);

  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth();
  const currentDay = today.getDate();

  let age = currentYear - birthYear;

  // Ajustar si aún no ha pasado el cumpleaños
  if (currentMonth < birthMonth ||
      (currentMonth === birthMonth && currentDay < birthDay)) {
    age--;
  }

  return age;
}

isConditionSelected(condition: any, pax: any): boolean {
  const paxSelect = this.paxesInItems.find(c => Number(c.idUnique) === Number(pax.idUnique));

  if (!paxSelect || !paxSelect.conditionInsurance) {
    return false;
  }

  // Comparar los JSON strings
  const conditionJson = JSON.stringify(condition);
  const selectedJson = JSON.stringify(paxSelect.conditionInsurance);

  return conditionJson === selectedJson;
}


isNationalFlight(flight: any): boolean {
  return !!(flight?.iataCityArrivalOut && flight.iataCityArrivalOut.trim());
}

getNationalFlights(item: any): any[] {
  return this.getFlightsWithDebug(item).filter(flight => this.isNationalFlight(flight));
}

getInternationalFlights(item: any): any[] {
  return this.getFlightsWithDebug(item).filter(flight => !this.isNationalFlight(flight));
}

getFlightsWithDebug(item: any): any[] {
  if (!this.itinerary?.flights || this.itinerary.flights.length === 0) return [];

  const payload = item.payload[0];
  const arrivalDate = new Date(item.arrivalDate);
  const departureDate = new Date(item.departureDate);

  const { pickupLocation, dropoffLocation } = payload.transfers;
  const pickupIsAirport = pickupLocation?.type === 'airport';
  const dropoffIsAirport = dropoffLocation?.type === 'airport';

  // Sin aeropuerto en origen o destino, no hay vuelo que matchear
  if (!pickupIsAirport && !dropoffIsAirport) {
    return [];
  }

  const pickupIata = pickupLocation?.address;
  const dropoffIata = dropoffLocation?.address;

  // Helper para comparar solo fecha
  const compareDateOnly = (dateStr: string): Date => {
    if (!dateStr) return new Date(0);
    return new Date(dateStr.split('T')[0]); // Solo YYYY-MM-DD
  };

  const sameDate = (a: Date, b: Date): boolean => a.getTime() === b.getTime();

  return this.itinerary.flights.filter(flight => {
    // Determinar si es nacional (tiene cityArrivalOut)
    const isNational = this.isNationalFlight(flight);

    // NACIONAL: cada tramo trae su propio origen (airportIataCodeOut/departureOut)
    // y destino (iataCityArrivalOut/arrivalOut); no depende del sufijo In/Out ni
    // de flight_direction (que indica salida/vuelta a la base, no el rol de ESTE
    // aeropuerto). Por eso matcheamos el iata contra el extremo correcto del tramo
    // según sea pickup (llegada) o dropoff (salida).

    if (isNational) {

      if (!flight.flyNumberOut?.trim()) {
        return false;
      }



      if (pickupIsAirport && !dropoffIsAirport) {
        // AEROPUERTO -> CIUDAD: se recoge al pasajero que llega, por lo
        // que el pickup debe matchear el aeropuerto de LLEGADA del tramo
        // (iataCityArrivalOut), no el de salida (airportIataCodeOut).
        if (pickupIata && flight.iataCityArrivalOut !== pickupIata) {
          return false;
        }
        return true;
        const flightDate = compareDateOnly(flight.arrivalOut);
        return sameDate(flightDate, arrivalDate);
      }

      if (!pickupIsAirport && dropoffIsAirport) {
        // CIUDAD -> AEROPUERTO: se lleva al pasajero que sale, por lo
        // que el dropoff debe matchear el aeropuerto de SALIDA del tramo
        // (airportIataCodeOut).
        if (dropoffIata && flight.airportIataCodeOut !== dropoffIata) {
          return false;
        }
        return true;
        const flightDate = compareDateOnly(flight.departureOut);
        return sameDate(flightDate, departureDate);
      }

      // AEROPUERTO -> AEROPUERTO: un vuelo nacional es un solo tramo,
      // no puede cubrir llegada y salida a la vez
      return false;
    }

    // INTERNACIONAL: los campos In/Out sí representan tramos distintos del mismo vuelo
    // Caso CIUDAD -> AEROPUERTO
    if (!pickupIsAirport && dropoffIsAirport) {
      // Necesita flyNumberOut
      if (!flight.flyNumberOut?.trim()) {
        return false;
      }

      // El aeropuerto de salida del vuelo debe coincidir con el dropoff
      if (dropoffIata && flight.airportIataCodeOut !== dropoffIata) {
        return false;
      }
      return true;
      // departureOut debe estar DESPUÉS de departureDate
      // const flightDate = compareDateOnly(flight.departureOut);
      // return flightDate >= departureDate;
    }

    // Caso AEROPUERTO -> CIUDAD
    if (pickupIsAirport && !dropoffIsAirport) {
      // Necesita flyNumberIn
      if (!flight.flyNumberIn?.trim()) {
        return false;
      }

      // El aeropuerto de llegada del vuelo debe coincidir con el pickup
      if (pickupIata && flight.airportIataCodeIn !== pickupIata) {
        return false;
      }
      return true;
      // arrivalIn debe estar ANTES de arrivalDate
      // const flightDate = compareDateOnly(flight.arrivalIn);
      // return flightDate <= arrivalDate;
    }

    // Caso AEROPUERTO -> AEROPUERTO
    if (pickupIsAirport && dropoffIsAirport) {
      // Necesita ambos vuelos
      if (!flight.flyNumberIn?.trim() || !flight.flyNumberOut?.trim()) {
        return false;
      }

      // Ambos aeropuertos del vuelo deben coincidir con pickup/dropoff
      if (pickupIata && flight.airportIataCodeIn !== pickupIata) {
        return false;
      }
      if (dropoffIata && flight.airportIataCodeOut !== dropoffIata) {
        return false;
      }
      return true;
      // arrivalIn debe estar ANTES de arrivalDate
      // departureOut debe estar DESPUÉS de departureDate
      // const arrivalInDate = compareDateOnly(flight.arrivalIn);
      // const departureOutDate = compareDateOnly(flight.departureOut);
      // return arrivalInDate <= arrivalDate && departureOutDate >= departureDate;
    }

    // Caso CIUDAD -> CIUDAD
    return false;
  });
}

getFlightForm(item: any): FormGroup {

  if (!this.needsFlight(item)) {
    return null;
  }

  if (!this.flightForms.has(item.id)) {
    const form = this.fb.group({
      selectedFlight: [null, Validators.required]
    });

    const transfer = this.itemsNewArr.find(c => c.id === item.id);

    // Suscribirse a cambios
    form.get('selectedFlight')?.valueChanges.subscribe(flight => {
      if (flight) {

        transfer.selectedFlight = flight;
        item.selectedFlight = flight;
      } else {
        delete transfer.selectedFlight;
        delete item.selectedFlight;
      }
    });

    this.flightForms.set(item.id, form);
  }

  return this.flightForms.get(item.id)!;
}

getSelectedFlightForItem(item: any): any {
  const form = this.getFlightForm(item);
  return form.get('selectedFlight')?.value;
}

getFlightControl(item: any): AbstractControl | null {
  const form = this.getFlightForm(item);
  return form ? form.get('selectedFlight') : null;
}

needsFlight(item: any): boolean {
  const payload = item.payload?.[0];
  if (!payload?.transfers) return false;

  const { pickupLocation, dropoffLocation } = payload.transfers;
  const pickupIsAirport = pickupLocation?.type === 'airport';
  const dropoffIsAirport = dropoffLocation?.type === 'airport';

  // Necesita vuelo si: ciudad->aeropuerto, aeropuerto->ciudad, o aeropuerto->aeropuerto
  return (!pickupIsAirport && dropoffIsAirport) ||  // ciudad->aeropuerto
         (pickupIsAirport && !dropoffIsAirport) ||  // aeropuerto->ciudad
         (pickupIsAirport && dropoffIsAirport);     // aeropuerto->aeropuerto
}

getCommentsProviderInner(commentsProvider: any): SafeHtml {
if(!commentsProvider) {
  return '';
}

return this.sanitizer.bypassSecurityTrustHtml(commentsProvider);
}

getQuestionsExists(item: any, questionType: string): boolean {

  if(questionType === 'HOTEL') {
      return item.experience.questions.some(c => c.code === questionType || c.code === 'HOTEL_NAME');
  }

  return item.experience.questions.some(c => c.code === questionType);

}


getDataPaxInItems(item: any, questionType: string): string {

  if(this.paxesInItems && this.paxesInItems.length > 0) {
      const firstPax: any = this.paxesInItems.find(c => c.itemId === item.id);

      if(firstPax) {
        if(questionType === 'PHONENUMBER'){
          return firstPax.phone;
        }
        if(questionType === 'EMAIL') {
          return firstPax.email;
        }
      } else {
        return 'Seleccione el pasajero títular';
      }
  }


  return 'Seleccione el pasajero títular';
}

getSelectedHotelForm(item: any): string {

  const form = this.hotelForms.get(`${item.toursId}_${item.arrivalDate}_${item.departureDate}_${item.id}`);

  if(form) {
    if(form.value && form.value.destination && form.value.destination.name) {
      return form.value.destination.name;
    } else {
      return 'Seleccione un hotel';
    }
  }

  return 'Seleccione un hotel';
}

getAgeNumber(birthDate: Date | string): number {
  if (!birthDate) return 0;

  const today = new Date();
  let birth = new Date(birthDate);

  // Si la fecha es inválida, intentar parsear
  if (isNaN(birth.getTime())) {
    birth = moment(birthDate, ['YYYY-MM-DD', 'DD-MM-YYYY', 'YYYY-DD-MM']).toDate();
  }

  if (isNaN(birth.getTime())) {
    console.warn('Fecha inválida:', birthDate);
    return 0;
  }

  let age = today.getFullYear() - birth.getFullYear();
  const monthDiff = today.getMonth() - birth.getMonth();
  const dayDiff = today.getDate() - birth.getDate();

  if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
    age--;
  }

  return age;
}

getFlyInfoOptionTemplate(fly: any, item: any): string {
  let infoFly = '';
  const flyNational = this.isNationalFlight(fly);

  // El item manda: es el que define si el tramo relevante es de arribo
  // (pickup en aeropuerto) o de salida (dropoff en aeropuerto), no lo que
  // el vuelo tenga poblado (que puede traer ambos tramos a la vez).
  const itemPayload = item?.payload?.[0];
  const pickupIsAirport = itemPayload?.transfers?.pickupLocation?.type === 'airport';
  const dropoffIsAirport = itemPayload?.transfers?.dropoffLocation?.type === 'airport';

  if (flyNational) {
    // Nacional: el dato siempre viaja en los campos "Out".
    // El número de vuelo (flyNumberOut) no cambia.
    const isArrival = pickupIsAirport;
    const dateSource = isArrival ? fly?.arrivalOut : fly?.departureOut;
    const dateTime = dateSource ? {
      date: this.formatDateOnly(dateSource),
      time: this.formatTimeOnly(dateSource)
    } : { date: '', time: '' };
    const label = isArrival ? 'Arribo' : 'Salida';
    const destinoLabel = label === 'Arribo' ? 'llegada' : 'destino';

    infoFly = ` ${label} con ${destinoLabel} a ${fly.cityArrivalOut} el ${dateTime.date} ` +
      `a las ${dateTime.time} hs. - Nro. vuelo: ${fly.flyNumberOut}`;
  } else {
    // Internacional: los campos In/Out sí representan tramos distintos,
    // pero el mismo registro puede traer ambos a la vez (ida y vuelta).
    // Cuál mostrar lo decide el item, no cuáles campos vienen poblados.
    const parts: string[] = [];

    if (pickupIsAirport && fly.arrivalIn) {
      const arrival = {
        date: this.formatDateOnly(fly.arrivalIn),
        time: this.formatTimeOnly(fly.arrivalIn)
      };
      parts.push(`Arribo al ${fly.airportIn} el ${arrival.date} ` +
        `a las ${arrival.time} hs. - Nro. vuelo: ${fly.flyNumberIn}`);
    }

    if (dropoffIsAirport && fly.departureOut) {
      const departure = {
        date: this.formatDateOnly(fly.departureOut),
        time: this.formatTimeOnly(fly.departureOut)
      };
      parts.push(`Salida del ${fly.airportOut} el ${departure.date} ` +
        `a las ${departure.time} hs. - Nro. vuelo: ${fly.flyNumberOut}`);
    }

    infoFly = parts.join(' - ');
  }

  return infoFly;
}

formatDateOnly(dateString: string): string {

  if (!dateString) {
return '';
}
  return formatDate(dateString, 'dd/MM/yyyy', 'es-ES', 'UTC');
}

formatTimeOnly(dateString: string): string {
  if (!dateString) {
return '';
}
  return formatDate(dateString, 'HH:mm', 'es-ES', 'UTC');
}

parseDateAndTime(dateString: string): { date: string; time: string } {
  return {
    date: this.formatDateOnly(dateString),
    time: this.formatTimeOnly(dateString)
  };

}

}

